var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 13,
  fill: "none",
  viewBox: "0 0 8 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  d: "M7.248.685 1.544 5.727a1 1 0 0 0 .021 1.517l5.683 4.743"
})));
export { SvgArrowLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIxMyIgdmlld0JveD0iMCAwIDggMTMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGlkPSJWZWN0b3IgNCIgZD0iTTcuMjQ3NzIgMC42ODUwNTlMMS41NDM2NSA1LjcyNjYzQzEuMDg0ODEgNi4xMzIxOCAxLjA5NDk2IDYuODUxMTYgMS41NjUwOCA3LjI0MzU5TDcuMjQ3NzIgMTEuOTg3MiIgc3Ryb2tlPSJ3aGl0ZSIvPgo8L3N2Zz4K";